"use strict";
var Observable_1 = require('../../Observable');
var share_1 = require('../../operator/share');
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/share.js